export default __webpack_public_path__ + "static/media/sandbox.b4c44c11.jpeg";